import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { AppProvider } from "./context/AppContext";
import { AuthProvider } from "./context/AuthContext";
import { CustomerProvider } from "./context/CustomerContext";
import { Toaster } from "./components/ui/sonner";
import PublicLayout from "./components/PublicLayout";

import Home from "./pages/Home";
import Services from "./pages/Services";
import Offers from "./pages/Offers";
import Booking from "./pages/Booking";
import MyBookings from "./pages/MyBookings";
import Contact from "./pages/Contact";
import PaymentResult from "./pages/PaymentResult";
import CustomerCallback from "./pages/CustomerCallback";

import AdminLogin from "./admin/AdminLogin";
import AdminLayout from "./admin/AdminLayout";
import Overview from "./admin/Overview";
import BookingsManage from "./admin/BookingsManage";
import ServicesManage from "./admin/ServicesManage";
import OffersManage from "./admin/OffersManage";
import ReviewsManage from "./admin/ReviewsManage";
import DesignEditor from "./admin/DesignEditor";
import ContactSettings from "./admin/ContactSettings";
import EmailSettings from "./admin/EmailSettings";
import PaymentSettings from "./admin/PaymentSettings";
import SecuritySettings from "./admin/SecuritySettings";

const Public = (C) => (
  <PublicLayout>
    <C />
  </PublicLayout>
);

function App() {
  return (
    <AppProvider>
      <AuthProvider>
        <CustomerProvider>
          <BrowserRouter>
            <Toaster position="top-center" richColors />
            <Routes>
              <Route path="/" element={Public(Home)} />
              <Route path="/services" element={Public(Services)} />
              <Route path="/offers" element={Public(Offers)} />
              <Route path="/book" element={Public(Booking)} />
              <Route path="/my-bookings" element={Public(MyBookings)} />
              <Route path="/contact" element={Public(Contact)} />
              <Route path="/payment-result" element={Public(PaymentResult)} />
              <Route path="/auth/customer" element={<CustomerCallback />} />

              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Overview />} />
                <Route path="bookings" element={<BookingsManage />} />
                <Route path="services" element={<ServicesManage />} />
                <Route path="offers" element={<OffersManage />} />
                <Route path="reviews" element={<ReviewsManage />} />
                <Route path="design" element={<DesignEditor />} />
                <Route path="contact" element={<ContactSettings />} />
                <Route path="email" element={<EmailSettings />} />
                <Route path="payment" element={<PaymentSettings />} />
                <Route path="security" element={<SecuritySettings />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </CustomerProvider>
      </AuthProvider>
    </AppProvider>
  );
}

export default App;
